import React, { useState } from "react";
import '../MenuComponent.scss';

export function Tabs({ children }) {
    function findActiveTab(a) {
        return a.reduce((accumulator, currentValue, i) => {
            if (currentValue.props.active) {
                return i;
            }

            return accumulator;
        }, 0);
    }

    function tabValidator(tab) {
        return tab.type.displayName === "Tab" ? true : false;
    }

    const [activeTab, setActiveTab] = useState(findActiveTab(children));
    return (
        <>
            <div className="tw-flex tw-gap-2 tw-justify-left tw-px-16">
                {children.map((item, i) => {
                    return (
                        <>
                            {tabValidator(item) && (
                                <Tab
                                    key={`tab-{i}`}
                                    currentTab={i}
                                    activeTab={activeTab}
                                    setActiveTab={setActiveTab}
                                >
                                    {item.props.children}
                                </Tab>
                            )}
                        </>
                    );
                })}
            </div>
            <div className="tw-px-16">
                {children.map((item, i) => {
                    return (
                        <div className={` ${i === activeTab ? "tw-visible" : "tw-hidden"}`}>
                            <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
                                {item.props.component &&
                                    item.props.component.map(element => {
                                        console.log(element)
                                        return <div className="tw-mt-2 tw-col-span-1">
                                            <h4 className="tw-font-bold tw-mb-0">
                                                {element.name}
                                            </h4>
                                            <p className=" menu-item-desc">{element.description}</p>
                                            {element.price}
                                            {element.list ? <>
                                                <h6 className="mt-4">{element.list.text}</h6>
                                                <ul className="px-4 pt-2" style={{fontSize: "14px", listStyle: "disc"}}>
                                                    {element.list.options.map(listItem => {
                                                        return <li>{listItem}</li>
                                                    })}
                                                </ul>
                                            </> : <></>}
                                            {element.subDesc ? <>
                                                <i>{element.subDesc}</i>
                                            </> : <></>}
                                        </div>

                                    })}
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
}

export function Tab({ children, activeTab, currentTab, setActiveTab }) {
    return (
        <>
            <div
                className={`tw-uppercase tw-mr-8 tw-py-3 tw-rounded tw-cursor-pointer
      ${activeTab === currentTab ? "underline text-white" : "text-gray-400"}`}
                onClick={() => setActiveTab(currentTab)}
            >
                {children}
            </div>
        </>
    );
}

Tab.displayName = "Tab";
